import React from 'react';
export function TimelineSection() {
  const timelineItems = [{
    period: 'September - October:',
    events: ['Set up on Wonde and STAR.', 'Administer baseline STAR assessments with all students.', 'Complete the Eedi dynamic quiz for all students.', 'Teachers complete the initial survey.', 'Attend training sessions with all participating teachers.', 'Designate a lead teacher/coordinator within your school.']
  }, {
    period: 'October onwards:',
    events: ["Engage with Eedi's full set of features, including diagnostics, interventions, and automated retrieval practice regularly.", 'Participate in shorter, innovative pilots with groups of, or all students. Details will be shared when the pilots are designed.']
  }, {
    period: 'January:',
    events: ['Administer the midline STAR assessments and complete another round of the Eedi dynamic quiz.']
  }, {
    period: 'June - July:',
    events: ['Administer endline STAR assessments and complete the final Eedi dynamic quiz.']
  }];
  return <div className="bg-white rounded-xl shadow-md p-6" data-id="element-30">
      <h2 className="text-2xl font-bold mb-6" data-id="element-31">Program Timeline</h2>
      <div className="space-y-8" data-id="element-32">
        {timelineItems.map((item, index) => <div key={index} data-id="element-33">
            <h3 className="font-bold text-lg text-purple-700 mb-3" data-id="element-34">
              {item.period}
            </h3>
            <ul className="space-y-2 pl-5" data-id="element-35">
              {item.events.map((event, eventIndex) => <li key={eventIndex} className="flex items-start" data-id="element-36">
                  <span className="text-purple-600 mr-2" data-id="element-37">●</span>
                  <span className="text-gray-700" data-id="element-38">{event}</span>
                </li>)}
            </ul>
          </div>)}
      </div>
    </div>;
}